import { useFormik } from 'formik'
import { useRouter } from 'next/router'
import { CreateAccountForm as Form } from 'ui-components'
import * as yup from 'yup'

import { signOut } from 'aws-amplify/auth'
import { useSignUpOtpMutation } from 'user-auth/App/ConfirmSignUp'
import { getConfirmCodeLink } from 'user-auth/helpers/getConfirmCodeLink'
import { useAuth } from 'user-auth/hooks/useAuth'
import { useAtom } from 'user-auth/libs/jotai'
import { atoms } from 'user-auth/states/form'

const schema = yup.object().shape({
  firstName: yup.string().required('First name is required'),
  lastName: yup.string().required('Last name is required')
})

export function CreateAccountForm(props) {
  const router = useRouter()
  const { authenticated } = useAuth()

  const [email] = useAtom(atoms.otp.email)
  const [, setFirstName] = useAtom(atoms.otp.firstName)
  const [, setLastName] = useAtom(atoms.otp.lastName)

  const { mutate: signUp } = useSignUpOtpMutation()

  const form = useFormik({
    validationSchema: schema,
    initialValues: {
      firstName: '',
      lastName: ''
    },
    onSubmit: async (values) => {
      const { firstName, lastName } = values
      setFirstName(firstName)
      setLastName(lastName)
      await signUp({
        email,
        firstName,
        lastName
      })
      router.push(getConfirmCodeLink('sign-up'))
    }
  })

  const handleClick = async () => {
    await signOut()
  }

  return (
    <Form
      render={[authenticated ? 'authenticated' : '']}
      slotProps={{
        Form: {
          component: 'form',
          onSubmit: form.handleSubmit
        },
        Header: props?.slotProps?.Header,
        FirstnameInput: form.getFieldProps('firstName'),
        LastnameInput: form.getFieldProps('lastName'),
        AuthenticatedBanner: {
          email,
          onActionClick: handleClick
        },
        Button: {
          loading: form.isSubmitting,
          disabled: !form.isValid
        }
      }}
    />
  )
}
